<template>
  <div class="input-group" :class="{ 'input-group-sm': isSmall }">
    <slot></slot>
    <svg-icon
      v-if="isClearDate"
      class="inside-el"
      style="right: 50px; transform: translateY(50%);"
      :name="'cross'"
      :width="18"
      :height="18"
      @click:icon="clearDate"
    ></svg-icon>
    <div class="input-group-append" @click="clickIcon">
      <span class="input-group-text bg-primary icon icon-calendar"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseCalendarWrap',
  components: {
    SvgIcon: () => import('@/components/SvgIcon.vue')
  },
  props: {
    isSmall: {
      type: Boolean,
      required: false,
      default: false
    },
    isClearDate: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({}),
  computed: {},
  methods: {
    clickIcon() {
      this.$children[0].$refs.datepick._flatpickr.open()
    },
    clearDate() {
      if (this.$children[0].$refs.datepick && this.$children[0].$refs.datepick._flatpickr) {
        this.$children[0].$refs.datepick._flatpickr.clear()
      }
    }
  }
}
</script>
